/** Timeline View Component
*/

'use strict'

var Marionette = require('marionette')
var App = require('app')
var Masonry = require('masonry-layout')
var _ = require('lodash')

/**
 * Timeline List Item
 * -----------------------------------------------------------------------------
 * The actual timeline item
 */
var TimelineListItemView = Marionette.View.extend({
  template: require('./templates/timeline-list-item.html'),
  tagName: 'div',
  className: 'timeline__item',
  triggers: {
    'click .js-edit': 'timeline-item:edit'
  },
  templateContext: function () {
    var self = this
    return {
      getOwnerName: function () {
        if (!_.has(self.model.attributes, 'owner')) return 'system'
        return _.get(self.model.attributes, 'owner.name')
      },
      userHasRole: App.TemplateHelpers.userHasRole,
      getConditionalStr: App.TemplateHelpers.getConditionalStr,
      getDeviceTypeLabel: App.TemplateHelpers.getDeviceTypeLabel,
      formatTime: App.TemplateHelpers.formatTime
    }
  },
  modelEvents: {
    'change': 'render'
  }
})

module.exports.TimelineListItemView = TimelineListItemView

/**
 * Timeline Collection View
 * -----------------------------------------------------------------------------
 *
 */
var TimelineCollectionView = Marionette.CompositeView.extend({
  template: require('./templates/timeline-collection.html'),
  childView: TimelineListItemView,
  childViewContainer: '.js-timeline-container',
  className: 'timeline__section',
  initialize: function () {
    var that = this
    this.collection = this.model.get('collection')

    //
    this.listenTo(this, 'childview:timeline-item:edit', function (data) {
      that.trigger('timeline-item:edit', data)
    })
  },
  onDomRefresh: function () {
    var that = this
    var timelineElement = that.el.querySelector('.js-timeline')

    setTimeout(function () {
      // this fixes the jumping of the page when loading more elements
      // but this needs some finetuning.
      timelineElement.style.height = that.el.scrollHeight + 'px'

      var msnry = new Masonry(timelineElement, {
        itemSelector: '.timeline__item',
        transitionDuration: 0
      })
      _.forEach(that.el.querySelectorAll('.timeline__item'), function (item) {
        if (item.style.left !== '0px') item.classList.add('right')
      })
    }, 0)
  }

})
module.exports.TimelineCollectionView = TimelineCollectionView

/**
 * Timeline Layout View
 * -----------------------------------------------------------------------------
 * Creates a proxy collection of the timeline items to create the correct format
 *
 */
var TimelineLayoutView = Marionette.CompositeView.extend({
  template: require('./templates/timeline-layout.html'),
  className: 'timeline__container',
  childView: TimelineCollectionView,
  childViewContainer: '.js-timeline-sections',
  initialize: function () {
    this.originalCollection = this.collection
    this.listenTo(this.originalCollection.pageableCollection, 'request', this.showLoader)
    this.listenTo(this.originalCollection.pageableCollection, 'sync error destroy', this.hideLoader)

    this.collection = this.createProxyCollection(this.originalCollection)
  },
  onDomRefresh: function () {
    // check if the loader needs to be visible
    if (this.originalCollection.pageableCollection.fetching) {
      return this.showLoader()
    }
  },
  showLoader: function () {
    this.el.classList.add('loading')
  },
  hideLoader: function () {
    this.el.classList.remove('loading')
  },
  createProxyCollection: function (originalColl) {
    var self = this
    var TimelineYearModel = Backbone.Model.extend({})
    var TimelineYearCollection = Backbone.Collection.extend({
      model: TimelineYearModel
    })
    var TimelineModel = Backbone.Model.extend({})
    var TimelineCollection = Backbone.Collection.extend({
      model: TimelineModel
    })
    var proxyCollection = new TimelineCollection()
    var prevModelYear

    var refreshProxyCollection = function (callback) {
      var yearCollections = {}
      _.forEach(originalColl.models, function (model) {
        var startDate = new Date(model.get('startDate'))
        var modelYear = startDate.getFullYear()

        if (!yearCollections[modelYear]) {
          yearCollections[modelYear] = new TimelineYearCollection()
        }

        yearCollections[modelYear].add(model, {silent: true})
      })

      _.forEach(yearCollections, function (value, key) {
        proxyCollection.add({
          'label': key,
          'collection': value
        }, {silent: true})
      })

      return callback()
    }

    var debouncedRefreshProxyCollection = _.debounce(refreshProxyCollection, 100)

    originalColl.on('reset add remove change', function () {
      proxyCollection.reset([], {silent: true})

      // debounced refreshproxycollection because we don't need to refresh on every change of the collection
      debouncedRefreshProxyCollection(function () {
        self.render()
      })
      //
    })

    return proxyCollection
  },
  templateContext: function () {
    var self = this
    return {
      getEmptyTitle: function () {
        if (this.title) return this.title
        return 'Whoops! no items.'
      },
      getEmptySubTitle: function () {
        if (this.subTitle) return this.subTitle
        return ''
      },
      isLoading: function () {
        if (self.originalCollection.pageableCollection) return self.originalCollection.pageableCollection.fetching
        return self.originalCollection.fetching
      },
      hasItems: function () {
        return self.collection.length > 0
      },
      hasMoreItems: function () {
        console.log('has more items')
        if (!self.originalCollection) return false
        if (!self.originalCollection.pageableCollection) return false
        var state = self.originalCollection.pageableCollection.state
        if (((state.currentPage + 1) * state.pageSize) < state.totalRecords) {
          return true
        } else {
          return false
        }
      }
    }
  }

})

module.exports.TimelineLayoutView = TimelineLayoutView



// WEBPACK FOOTER //
// ./js/components/timeline-view/index.js